import {
  LayoutService,
  RestLayoutService
} from '@sitecore-jss/sitecore-jss-angular';

export class LayoutServiceFactory {
  create(): LayoutService {
    return new RestLayoutService({
      apiHost: '',
      apiKey: '{2A4DCA72-3283-4714-B8C9-D175B84CF9F4}',
      siteName: '',
      configurationName: 'jss'
    });
  }
}

export const layoutServiceFactory = new LayoutServiceFactory();
